/* global firebase_path, session_id, merchant_id, firebase, table_id */
import React, { Component } from "react";
import TopNav from '../../../TopNav';
import SnackBarModal from '../../../../jsx/modal/SnackBarModal';
import ConfirmModal from '../../../../jsx/modal/ConfirmModal';
import OrderItem from '../../../../Model/OrderItem';
import MerchantAppData from '../../../../Model/MerchantAppData';
import ChangeTableModal from '../table/ChangeTableModal';
import PendingQueue from '../BackgroundQueue/PendingQueue';

import AccessLevel from '../../AccessLevel';
import MerchantPrinter from '../Util/MerchantPrinter'
import MessageModal from '../../../../jsx/modal/MessageModal';
import SelectTableSession from './component/SelectTableSession';
import TableSessionHelper from '../../../../Model/TableSession';
import MergeOrderModal from '../../../../jsx/modal/MergeOrderModal';
import { PulseLoader } from 'halogenium';
import { Bill, BillStatus } from '../../../../Model/Bill';
import { TableSessionType } from '../../../../app/Common/Enum/TableSessionType';
import ReactHelper from '../../../../util/ReactHelper';
import Variation from '../../../../Model/Variation';
import PrinterFunction from '../../../../Model/PrinterFunction';
import CalculationHelper from '../../../admin/table_session/helper/CalculationHelper';
import { setNumberHeader, sortBySetNumber } from '../../../../Model/Order';
import PoleDisplay from '../../../../app/Merchant/Hardware/PoleDisplay/PoleDisplay';
import BillRepository from '../../../repository/BillRepository';
import MerchantSettingKey from '../../../../app/Common/Enum/MerchantSettingKey';
import OrderRepository from '../../../../app/Merchant/Repository/OrderRepository';
import { toast } from 'react-toastify';
import Table from '../../../../Model/Table';
import GenerateTemporaryQrModal from '../../../../jsx/modal/GenerateTemporaryQrModal';
import TemporaryTableQrRepository from '../../../repository/TemporaryTableQrRepository';
import TableSessionCreatedBy from './component/AdminOrder/TableSessionCreatedBy';
import './AdminOrder.scss'
import SelectMembershipModal from "../../../../jsx/modal/SelectMembershipModal";
import TableSessionService from "../../../../app/Merchant/service/TableSessionService";
import MembershipRepository from "../../../../app/Merchant/Repository/MembershipRepository";
import BaseModal from "../../../../jsx/modal/BaseModal";
import ApplyMembershipBenefitForm from "../../../../app/Merchant/Membership/ApplyMembershipBenefitForm";
import MembershipFreeItemRepository from "../../../../app/Merchant/Repository/MembershipFreeItemRepository";

const OrderBy = {
    USER: 1,
    ADMIN: 2
}

const TableStatus = {
    OPEN: 0,
    SITTING: 1,
    BILLING: 2,
}

const PrintMode = {
    Bill: "bill",
    GuestCheck: "guest-check",
}

export const OrderStyle = {
    NORMAL  : 0,
    SET_BY_SET  : 1,
}
var a = []
class AdminOrder extends Component {
    constructor(props) {
        super(props)

        this.voidItemMap = {}
        this.state = {
            orders: [],
            confirmOrder: [],
            draftOrder: [],
            menuItems: [],
            variations: [],
            addons: [],
            options: [],
            selectedAddOns: [],
            selectedOptions: [],
            sessions: [],
            selectedOrder: {
                itemName: "",
                itemPrice: "",
                itemTotal: this.props.app.state.currencyName+" 0.00"
            },
            editingMenuItem: null,
            editingOrder: null,
            table: null,
            table_session: null,
            total: 0,
            snackbarMessage: null,
            vh: window.innerHeight * 0.01,

            // To keep track of Void item API progress
            voidItemMap: this.voidItemMap,

            isAllSideDishCompleted: true,
            draftSetTakeAwayClicked: false,
            draftSetDineInClicked: false,

            // Store Ids of order that has insufficient stock
            inventoryLowStock: {},

            isNeedHandleInventory: this.props.app.isInventoryModuleEnabled(),

            membershipModal: null,
            assigningMembership: false,
            loadingMembership: false,

            membershipActionModal: null,
            applyMembershipBenefitModal: null,
        }

        this.onBackButtonClicked = this.onBackButtonClicked.bind(this)
        // this.confirmOrder = this.confirmOrder.bind(this)
        this.confirmAllOrder = this.confirmAllOrder.bind(this)
        this.cancelOrder = this.cancelOrder.bind(this)

        this.confirmModalRef = React.createRef()

        // Keep track of whether this machine is the machine that
        // is running Orderlah Printer Manager, and Orderlah Printer Manager
        // is running normally. Then we can trigger cash drawer directly from API,
        // instead of sending request to Orderlah server to be later passed back to
        // Orderlah Printer Manager via websocket connection
        this.orderlahPrinterManagerConnected = false

        this.callbackKey = "AdminOrder"
    }

    // If set currentSession to null then will cause error at settlement page
    // 1. Settlement page read "currentSession" to perform calculation
    // 2. We might need to set another variable to store the session to be used at
    //    settlement page
    // componentWillUnmount = () => {
    //     this.props.app.setState({currentSession: null})
    // }

    componentDidMount() {
        this._isMounted = true
        if (this.props.app.state.adminOrders.length == 0) {
            this.props.app.loadOrders(this.props.match.params.tableID)
        }
        // Update vh when window resize
        window.addEventListener('resize', this.windowResizeListener);

        this.handleTableSessions()

        //Setup sortby
        let adminOrderSortByDesc = localStorage.getItem("admin_order_sortby") || "true"
        let result = (adminOrderSortByDesc == "true") ? true : false

        this.props.app.setState({
            sort_by: result,
        });
        $(document).on('app.admin-orders-changed', this.handleNewOrderAdded)

        // Check connection, and set timer to recheck every 10 second
        PrinterFunction.checkPrinterManagerConnected()

        $(document).on('app.admin-orders-cancelled', this.handleInventory)
        $(document).on('app.admin-orders-dummy-session-upgraded', this.handleDummySessionUpgraded)

        $(document).trigger('AdminOrder.ready')
        this.loadBill()
        this.loadTemporaryTableQr()
    }

    loadBill = () => {
        const billId = this.props.app.state.currentSession && this.props.app.state.currentSession.bill_id
        const { bill, } = this.state
        if (billId) {
            if (!bill) {
                if (this.waitingForBillOfId != billId) {
                    // Prevent keep firing same function
                    this.waitingForBillOfId = billId

                    // Bill not loaded, load now
                    BillRepository.getInstance().loadOne(parseInt(billId), (bill) => {
                        this.setState({bill})
                        this.waitingForBillOfId = null
                    }, this.callbackKey, this)
                }
            }
            else if (bill && bill.id != billId) {
                // Viewing wrong bill, set to null to trigger reload
                this.setState({bill: null})
            }
        }
        else {
            if (bill) {
                this.setState({bill: null})
            }
        }
    }
    loadTemporaryTableQr = () => {
        TemporaryTableQrRepository.getInstance().loadAll(tempTableQrs => {
            this.setState({tempTableQrs}, () => {
                this.setState({
                    tempTableQrsLoaded: true
                })
            })
        }, this.callbackKey, this)
    }
    handleDummySessionUpgraded = (e, dummyTableSessionId, newTableSessionId) => {
        if (dummyTableSessionId && newTableSessionId) {
            let { currentSession, } = this.props.app.state

            // We are at dummy session that is being removed, we shall 'replace' it with the
            // newly created table session
            if (currentSession.id == dummyTableSessionId) {
                this.setState({
                    replaceTableSessionId: newTableSessionId,
                }, this.handleTableSessions)
            }
        }
    }
    handleTableSessions = () => {
        // Make sure orders and table sessions are loaded first, else will point to dummy session
        // even when we have active table session
        if (!this.props.app.state.tableSessionLoaded || !this.props.app.state.ordersLoaded || !this.state.tempTableQrsLoaded) {
            return
        }

        const tableSessions = this.getTableSessions()
        const thisTableTempTableSessions = this.getTempSessions()
        const pointToDummySession = (otherStateUpdate = {}) => {
            // This table do not has any active table session,
            // we assign dummy session
            let stateToUpdate = {
                ...otherStateUpdate
            }
            if (thisTableTempTableSessions.length == 0) {
                // No dummy table session to store order.
                // We create a dummy session now
                let tempSessions = this.props.app.state.tempSessions
                const newTempSession = TableSessionHelper.getNewTempTableSession(this.props.match.params.tableID)
                tempSessions.push(newTempSession)
                stateToUpdate["tempSessions"] = tempSessions
                stateToUpdate["currentSession"] = newTempSession
            }
            else {
                // Take first dummy session as current session
                stateToUpdate["currentSession"] = thisTableTempTableSessions[0]
            }
            this.props.app.setState(stateToUpdate)
        }

        // Override below logic if user explicitly set to create new/point to dummy session
        // on QuickPos Mode navigate from AdminOrder --> Settlement --> Complete Settlement --> AdminOrder
        if (this.props.app.state.isShowNewTicketAfterSettlement) {
            // Reset the flag, handle once for every Settlement made
            let isShowNewTicketAfterSettlement = false
            pointToDummySession({isShowNewTicketAfterSettlement})
            return
        }


        // Priority given to 'last' dummy session. Flow when have 0 active table session
        // 1. Add draft orders to dummy table session
        // 2. Click confirm <-- we set the flag 'isPlacingOrder' during this step
        // 3. Change page to /pos (handling for Quick POS disabled, which is default)
        // 4. (Quick POS Enabled) Auto redirect from /pos back to AdminOrder

        //    Below are consideration for Quick POS Enabled
        // 5. A.   If we have 'placingOrder' table session, then go to this session (where 'isPlacingOrder' = true)
        //    B.   No placingOrder session, go to the first real Active session
        //    C.   No Active session, create a dummy session
        // 6. On completion of API, the dummy session that trigger the place order will be removed
        //    A.   If have 0 Active session and 1 dummy at first, now we have 1 Active, 0 dummy
        //         So point to the one and only Active session, no issue
        //    B.   If we have N Active session and 1 dummy session at first, now we have N + 1 Active and 0 dummy
        //         For UX consideration:
        //         i.   User click confirm
        //         ii.  User stay same page and see'Placing order'
        //              (Actually is jump to /pos, then back to AdminOrder)
        //         iii. Order placed, so should 'point' to the new session where order is placed
        //              Problem when 'loading' we are pointing to dummy session (that is removed by now),
        //              so we need to find the new session and change to there
        //         iv.  Since at (ii) we switch and recreate Component, usual callback does not work
        //         v.   The 'callback' from last unmounted Component shall trigger event to pass the information here
        //              and handled by handleDummySessionUpgraded()
        const placingOrder = thisTableTempTableSessions.find(sess => sess.isPlacingOrder)
        if (placingOrder) {
            this.props.app.setState({currentSession: placingOrder})
        }

        // 6Bv
        else if (this.state.replaceTableSessionId) {
            let newSession = this.getTableSessions().find(sess => sess.id == this.state.replaceTableSessionId)

            // There will be case where place order API completed thus triggering this event, but
            // Firebase update yet to complete, so the new table session is not loaded yet
            if (newSession) {
                this.props.app.setState({currentSession: newSession})
                this.setState({
                    replaceTableSessionId: null,
                })
            }
        }
        else if (tableSessions.length > 0) {
            // Has actual table session, take the first session
            let currentSession = this.getTableSessions()[0]
            this.props.app.setState({ currentSession })
            this.props.app.loadBill(currentSession)
        }
        else {
            pointToDummySession()
        }
    }
    getTableSessions = () => {
        let tableSessions = TableSessionHelper.getSessionsForTableWithActiveOrders({ id: this.props.tableId })
        if (this.state.tempTableQrs && this.state.tempTableQrs.length) {
            tableSessions = [...tableSessions]
            this.state.tempTableQrs.forEach(ttqr => {
                if (ttqr.table_id == this.props.tableId) {
                    let a = TableSessionHelper.find(ttqr.table_session_id)
                    if (a && tableSessions.find(ts => ts.id == a.id) == null) {
                        // Check for duplicate before add
                        tableSessions.push(a)
                    }
                }
            })
        }
        let filter = TableSessionHelper.getFilter()
        if (filter) {
            // We have other custom logic to filter the table sessions.
            // Case A - For pickup orders, only list those of matching customer id
            tableSessions = tableSessions.filter(filter)
        }
        return tableSessions
    }
    getTempSessions = () => {
        return this.props.app.state.tempSessions.filter(session => session.table_id == this.props.tableId)
    }

    windowResizeListener = () => {
        let vh = window.innerHeight * 0.01;
        this.setState({
            vh: vh
        })
    }
    componentWillUnmount() {
        this._isMounted = false
        window.removeEventListener('resize', this.windowResizeListener)
        this.props.app.unloadOrders()

        $(document).off('app.orders-changed', this.handleNewOrderAdded)
        if (this.orderPrinterManagerTimer) {
            clearInterval(this.orderPrinterManagerTimer)
        }

        $(document).off('app.admin-orders-changed', this.handleNewOrderAdded)
        $(document).off('app.admin-orders-cancelled', this.handleInventory)
        $(document).off('app.admin-orders-dummy-session-upgraded', this.handleDummySessionUpgraded)

        if (this.props.app.getMerchantSettingValue(MerchantSettingKey.HAS_POLE_DISPLAY) == 1) {
            PoleDisplay.getInstance().showDefaultText()
        }
        BillRepository.getInstance().removeCallback(null, this)
        TemporaryTableQrRepository.getInstance().removeCallback(null, this)
        MembershipRepository.getInstance().removeCallback(null, this)
    }

    componentDidUpdate(prevProps, prevState) {
        const {currentSession} = this.props.app.state
        if (currentSession) {
            if (currentSession.id > 0) {
                // Actual table session
                if (!this.getTableSessions().find(sess => sess.id == currentSession.id)) {
                    // Current session no longer exist, see to point to other session
                    this.handleTableSessions()
                }

                this.loadMembership()
            }
            else {
                // We are pointing to tempSession, default handling when table_sessions are
                // not done loading.
                if (!this.props.app.state.isAllowChooseTableSession) {
                    // Not allow to change table session, but we are pointing to dummy
                    // table session when there are actual table sessions available,
                    // change table session now
                    let tableSessions = this.getTableSessions()
                    if (tableSessions.length > 0) {
                        this.handleTableSessions()
                    }
                }
                else {
                    const tempSessions = this.getTempSessions()
                    if (tempSessions.find(sess => sess.id == currentSession.id) == null) {
                        this.handleTableSessions()
                    }
                }
            }
        }
        else {
            // Do not has table session yet, as during componentDidMount tableSessions are not loaded yet.
            // Set the table session now
            this.handleTableSessions()
        }
        ReactHelper.handleComponentDidUpdate(this, ["menuItems", "variations"], () => {
            this.handleInventory()
        })

        if (this.props.app.isInventoryModuleEnabled() != this.state.isNeedHandleInventory) {
            this.setState({
                isNeedHandleInventory: this.props.app.isInventoryModuleEnabled() == 1,
            }, this.handleInventory)
        }

        this.loadBill()
    }

    loadMembership() {
        if (this.props.app.state.currentSession.membership_id !== this.loadingMembershipId) {
            this.loadingMembershipId = this.props.app.state.currentSession.membership_id
            if (this.props.app.state.currentSession.id > 0 && this.props.app.state.currentSession.membership_id) {
                if (this.state.loadingMembership) {
                    clearTimeout(this.state.loadingMembership)
                }
                this.setState({
                    loadingMembership: setTimeout(() => {this.setState({loadingMembership: false})}, 10000),
                })
                MembershipRepository.getInstance().loadOne(this.props.app.state.currentSession.membership_id, (membership) => {
                    if (membership && Array.isArray(membership)) {
                        membership = membership[0]
                    }
                    if (this.state.loadingMembership) {
                        clearTimeout(this.state.loadingMembership)
                    }
                    this.setState({membership, loadingMembership: false})
                }, this.callbackKey, this)
            }
            else {
                this.setState({membership: null})
            }
        }
    }

    handleNewOrderAdded = () => {
        this.handleSideDish()
        if (this.props.app.isInventoryModuleEnabled()) {
            this.handleInventory()
        }
    }

    confirm(message, action) {
        this.confirmModalRef = this.confirmModalRef || React.createRef()
        this.setState({
            confirmAlert: <ConfirmModal
                buttonLayout="vertical"
                ref={this.confirmModalRef}
                message={message}
                onClose={() => {
                    this.setState({
                        confirmAlert: null
                    })
                }}
                onYes={() => {
                    // Pass modal to action function so that
                    // isLoading can be called when needed
                    action(this.confirmModalRef.current)
                }}
                onNo={() => {
                    this.confirmModalRef.current.close()
                }} />
        })
    }

    getTableStatus(tableId) {
        if (this.props.app.state.tables.length == 0) {
            return 0
        }

        let table = this.props.app.state.tables.find((item) => item.id == tableId)
        if (this.props.app.state.sessions.length > 0 && table) {
            let tableSession = this.props.app.state.sessions.find(elem => { return elem.table_id == table.id; })
            if (tableSession != null) {
                if (tableSession.bill_id != null) {
                    return 2
                } else {
                    return 1
                }
            }
        }
        return 0
    }

    afterChangeTable = () => {
        this.setState({ changeTable: null })
        this.props.history.push(`/pos`)
    }

    onChangeTable = (e) => {
        let tableId = this.props.match.params.tableID
        let table = this.props.app.state.tables.find((item) => item.id == tableId)
        this.setState({
            changeTable: table
        })
    }

    onClearTableClicked = () => {
        let message = ("Confirm to cancel all order?").replace("<br>", "\n");
        this.setState({
            confirmModal: <ConfirmModal
                ref={this.confirmModalRef}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.onCancelTable()
                }}
                onNo={() => {
                    this.setState({
                        confirmModal: null
                    })
                }} />
        })
    }

    /**
     * Cancel the table session due to all orders are voided
     */
    onCancelTable = () => {
        let tableId = this.props.match.params.tableID
        let table = this.props.app.state.tables.find((item) => item.id == tableId)

        let a = {
            action: () => {
                $.ajax({
                    url: `/merchant/tables/${table.id}/cancel`,
                    type: 'POST',
                    data: {
                        is_auto_close_bill: 1,
                        table_session_id: this.props.app.state.currentSession.id,
                        counter_id: this.props.app.state.counter?.id,
                    },
                })
                    .done(() => {
                        PendingQueue.remove(a)
                    })
                    .always(() => {
                    })
            },
            name: "Cancelling orders of Table " + table.id
        }
        PendingQueue.add(a)
        this.props.history.push(`/pos`)
    }

    onBackButtonClicked() {
        this.props.backClicked()
    }

    selectOrder = (e) => {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let order = this.getOrders().find((item) => item.id == id)
        this.props.app.setState({
            selectedOrder: order
        })

        if (!this.isPortrait()) {
            this.showItemDetail(order)
        }
    }

    editOrder = (e) => {
        e.stopPropagation()

        this.showItemDetail(this.props.app.state.selectedOrder)
    }

    isPortrait = () => {
        return window.innerHeight > window.innerWidth;
    }

    showItemDetail = (order) => {
        if (order.order_status == "draft") {
            this.props.history.push(`/table/${this.props.match.params.tableID}/category/${this.props.match.params.categoryID}/menu/${order.menu_item_id}/order`)
            return
        }
        if (this.props.location.pathname.includes('change_price')) {
            // We are at '.../change_price' route, if select other confirmed order, go back
            // to other route to close the ChangeOrderPrice component
            this.props.history.replace(`/table/${this.props.match.params.tableID}/category`)
        }

    }
    showEditPrice = (order) => {
        const categoryId = this.props.match.params.categoryID || order.getMenuItem().category_id
        this.props.history.push(`/table/${this.props.match.params.tableID}/category/${categoryId}/menu/${order.menu_item_id}/change_price`)
    }
    changePrice = (e) => {
        const { selectedOrder } = this.props.app.state
        if (!selectedOrder) {
            return
        }
        this.showEditPrice(selectedOrder)
    }
    cancelOrder(e) {
        MerchantAppData.cancelSelectedOrder(e, this.props, this.handleInventory);
    }

    voidOrder = (e) => {
        let me = this
        let orderID = this.props.app.state.selectedOrder.id
        let quantity = this.props.app.state.selectedOrder.quantity
        let quantityServed = this.props.app.state.selectedOrder.quantity_served

        if (quantity == quantityServed) {
            let message = lang.confirm_void_ask.replace("<br>", "\n");
            this.setState({
                confirmModal: <ConfirmModal ref={me.confirmModalRef} message={message}
                    buttonLayout="vertical"
                    onClose={() => {
                        me.setState({
                            confirmModal: null
                        })
                    }}
                    onYes={() => {
                        me.confirmModalRef.current.isLoading(true)
                        $.ajax({
                            url: "/merchant/api/order/" + orderID + "/status",
                            type: "POST",
                            data: {
                                order_status: "void",
                                printed: 0,
                                quantity_served: quantity,
                            },
                            success: (response) => {
                                me.props.app.setState({
                                    selectedOrder: {
                                        id: -1,
                                        itemName: "",
                                        itemPrice: "",
                                        itemTotal: this.props.app.state.currencyName+" 0.00"
                                    },
                                })

                                me.checkTable();
                            }
                        }).always(() => {
                            me.setState({
                                confirmModal: null
                            })
                        })
                    }}
                    onNo={() => {
                        me.setState({
                            confirmModal: null
                        })
                    }} />
            })
        }
        else {
            this.voidItemMap[orderID] = true
            this.setState({
                voidItemMap: {
                    ...this.voidItemMap,
                }
            })
            $.ajax({
                url: "/merchant/api/order/" + orderID + "/status",
                type: "POST",
                data: {
                    order_status: "void",
                    printed: 0,
                    quantity_served: quantity,
                    counter_id: this.props.app.state.counter?.id,
                },
                success: (response) => {
                    me.props.app.setState({
                        selectedOrder: {
                            id: -1,
                            itemName: "",
                            itemPrice: "",
                            itemTotal: this.props.app.state.currencyName+" 0.00"
                        },
                    })

                    me.checkTable();
                }
            })
                .always(() => {
                    this.voidItemMap[orderID] = false
                    this.setState({
                        voidItemMap: {
                            ...this.voidItemMap,
                        }
                    })
                })
        }
    }

    checkTable = () => {
        let adminOrders = this.getOrders()
        let confirmOrder = adminOrders.filter((order) => order.order_status == "accepted")
        if (confirmOrder.length == 0) {
            this.onCancelTable()
        }
    }

    openDrawer = (e) => {
        PrinterFunction.openDrawer()
    }

    printOrder = (e, mainPrinter) => {
        let me = this
        let sessionID = this.getOrders()[0].table_session_id

        MerchantPrinter.printBillBySession(sessionID, {
            mode: PrintMode.GuestCheck,
        }, (response) => {
            var x = document.getElementsByClassName("snackbar-body");
            x[0].className = "snackbar-body show-snack-bar";
            setTimeout(function () {
                x[0].className = x[0].className.replace("snackbar-body show-snack-bar", "snackbar-body");
            }, 3000);

            me.setState({
                snackbarMessage: lang.printing
            })
        })
    }

    serviceChargeFromServiceChargeGroup = () => {
        let serviceChargeGroupSetting = this.props.app.getMerchantSettingTextValue('service_charge_group')
        if (serviceChargeGroupSetting) {
            try {
                // Data structure
                // let format = {
                //     data: [
                //         {
                //             percent: 10,
                //             tables: [{id: 3}, {id: 4}]
                //         },
                //         {
                //             percent: 15,
                //             tables: [{id: 30}, {id: 40}]
                //         }
                //     ]
                // }
                const serviceChargeGroups = JSON.parse(serviceChargeGroupSetting)
                let scg = serviceChargeGroups.data.find(scg => {
                    return (scg.tables || []).find(table => table.id == this.props.match.params.tableID)
                })
                if (scg) {
                    return scg.percent
                }
            }
            catch (err) {
                console.log(err)
            }
        }
        return null
    }

    enterSettlement = (e) => {
        let adminOrders = this.getOrders()
        let gotTax = (this.props.app.state.merchant.tax_no != null) ? true : false;
        let scPercent = this.props.app.getMerchantSettingValue('service_charge')
        scPercent = scPercent ? parseFloat(scPercent) : 0

        let scPercentTakeAway = this.props.app.getMerchantSettingValue('service_charge_take_away')
        scPercentTakeAway = scPercentTakeAway ? parseFloat(scPercentTakeAway) : 0

        let extraSCstart = this.props.app.getMerchantSettingValue('extra_service_charge_start')
        let extraSCend = this.props.app.getMerchantSettingValue('extra_service_charge_end')
        let extraSCGetName = this.props.app.getMerchantSettingValue('extra_service_charge_name')
        let extraSCName = extraSCGetName != "" ? extraSCGetName : "Extra Surcharge"
        let extraSCPercent = this.props.app.getMerchantSettingValue('extra_service_charge_value')
        let extraSCValue = (extraSCPercent == null || extraSCPercent == 0) ? 0 : (extraSCPercent / 100.00);
        let serviceChargeRate = 0
        let today = moment().startOf('day');

        const isTakeAwayTable = Table.isTakeAwayTable(this.props.match.params.tableID)
        const serviceChargeFromServiceChargeGroup = this.serviceChargeFromServiceChargeGroup()
        if (serviceChargeFromServiceChargeGroup !== null) {
            serviceChargeRate = (serviceChargeFromServiceChargeGroup / 100).toFixed(2)
        }
        else if (isTakeAwayTable && scPercentTakeAway > 0) {
            serviceChargeRate = (scPercentTakeAway / 100.00).toFixed(2)
        }
        else if (scPercent > 0) {
            serviceChargeRate = (scPercent / 100.00).toFixed(2)
        }

        let roundTo = this.props.app.state.merchant.bill_round_to_nearest
        let billData = Bill.calculateBillDetailsForOrder({
            orders: adminOrders, isHasTax: gotTax, pickupTime: today, serviceCharge: serviceChargeRate, extraSCstart, extraSCend, extraSCName, extraSCValue, roundTo
        })
        let updateState = {
            // Reset selected orders to split bill
            splitBillSelectedOrderId: [],
        }

        let bill = this.props.app.state.bill
        bill = { ...bill, ...billData }
        updateState["bill"] = bill
        // if (!bill.hasBill) {

        // }
        // else {
        //     bill.cash = billData.total - (bill.total - bill.balance)
        // }

        this.props.app.setState(updateState)
        this.props.history.push(`/table/${this.props.match.params.tableID}/settlement`)
    }

    closeTable = () => {
        let message = "Confirm close table?"
        this.setState({
            confirmModal: <ConfirmModal
                ref={this.confirmModalRef}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.closeTableAPI(this.confirmModalRef.current, {
                        is_auto_close_bill: true,
                        tableId: this.props.match.params.tableID
                    })
                }}
                onNo={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
            />
        })
    }

    payBill = () => {
        let message = lang.confirm_pay + this.getTotalOrderPrice()
        this.setState({
            confirmModal: <ConfirmModal
                ref={this.confirmModalRef}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.confirmAllOrderAPI(this.confirmModalRef.current, { is_auto_close_bill: true })
                }}
                onNo={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
            />
        })
    }

    closeTableAPI = (confirmDialog, options, callback) => {
        options = options || {}
        confirmDialog.isLoading(true)

        let tableId = null
        if (options.tableId) {
            tableId = options.tableId
        }
        else {
            tableId = this.props.match.params.tableID
        }

        $.ajax({
            url: `/merchant/tables/${tableId}/close`,
            type: 'POST',
            data: {
                is_auto_close_bill: !!options.is_auto_close_bill ? 1 : 0,
            },
            success: () => {
                confirmDialog.close()
                if (callback) {
                    callback()
                }
            }
        })
            .fail((jqXHR) => {
                let json = JSON.parse(jqXHR.responseText);
                const message = json.message || lang.unable_to_place_order_order_manually;
                if (this._isMounted) {
                    this.setState({
                        errorMessage: message
                    })
                }
            })
    }

    getCurrentSessionDraftOrders = () => {
        return this.props.app.state.adminOrders.filter(order => {
            return order.order_status == "draft" && order.table_session_id == this.props.app.state.currentSession.id
        })
    }

    setDraftOrderAsDineIn = () => {
        this.setState({
            draftSetDineInClicked: true
        }, () => setTimeout(() => {
            this.setState({
                draftSetDineInClicked: false
            })
        }, 50))
        let orders = this.getOrders()
        orders.map((order) => {
            let orderTakeAwayCharge = order.menuItem.take_away_charge
            if ( orderTakeAwayCharge != -1 && order.take_away != 0 ) {
                if(this.props.app.state.selectedOrder && this.props.app.state.selectedOrder.menuItem && this.props.app.state.selectedOrder.take_away != 0){
                    let takeAwayCharge = this.props.app.state.selectedOrder.menuItem.take_away_charge
                    this.props.app.state.selectedOrder.take_away = 1
                    this.props.app.setState({selectedOrder :this.props.app.state.selectedOrder })
                }
                order.order_total = parseFloat(order.order_total) - (parseFloat(orderTakeAwayCharge) * order.quantity)
                order.take_away = 0
            }
        })
    }

    setDraftOrderAsTakeAway = () => {
        this.setState({
            draftSetTakeAwayClicked: true
        }, () => setTimeout(() => {
            this.setState({
                draftSetTakeAwayClicked: false
            })
        }, 50))
        let orders = this.getOrders()
        orders.map((order) => {
            let orderTakeAwayCharge = order.menuItem.take_away_charge
            if ( orderTakeAwayCharge != -1 && order.take_away != 1 ) {
                if(this.props.app.state.selectedOrder && this.props.app.state.selectedOrder.menuItem && this.props.app.state.selectedOrder.take_away != 1){
                    let takeAwayCharge = this.props.app.state.selectedOrder.menuItem.take_away_charge
                    this.props.app.state.selectedOrder.take_away = 0
                    this.props.app.setState({selectedOrder :this.props.app.state.selectedOrder })
                }
                order.order_total = parseFloat(order.order_total) + (parseFloat(orderTakeAwayCharge) * order.quantity)
                order.take_away = 1
            }
        })
    }

    confirmAllOrderAPI = (confirmDialog, options, callback) => {
        // Note: options shall be be modified. In case of API failed and need to retry,
        // we shall process the data again using the ORIGINAL options.
        // So if we need to modify any thing, please make a deep of the data and do not
        // directly modify the original data/object
        options = options || {}

        let me = this

        if (confirmDialog) {
            confirmDialog.isLoading(true)
        }

        // 1. We can pass in draftOrders from options
        // 2. Or by default will auto read draftOrders from this.props.app.state.adminOrders
        // (1) is safe to be retry the API call later
        // (2) is simple and only safe when synchronous (no other user
        //     interaction to modify this.props.app.state.adminOrders)
        let draftOrders = []
        let newOrders = []
        const currentSession = this.props.app.state.currentSession
        const tableSessionId = currentSession.id
        if (options.draftOrders) {
            // Deep copy data
            draftOrders = JSON.parse(JSON.stringify(options.draftOrders))
        }
        else {
            // let adminOrders = this.props.app.state.adminOrders
            let a = this.getCurrentSessionDraftOrders()
            draftOrders = JSON.parse(JSON.stringify(a))
        }

        const cleanUpPostData = (draftOrder) => {
            // Remove unwanted key-value and nested object to reduce
            // POST data size. POSTing too much unnecessary data will cause
            // data to be truncated at server side
            draftOrder.menuItem = null
            draftOrder.variation_ary = null
            if (draftOrder.side_dish_data && draftOrder.side_dish_data.selections) {
                draftOrder.side_dish_data.selections.forEach(sideDishSelection => {
                    sideDishSelection.variation = {
                        id      : sideDishSelection.variation.id,
                        name    : sideDishSelection.variation.name,
                        price   : parseFloat(sideDishSelection.variation.price || 0),
                    }
                })
            }
        }

        draftOrders.forEach(draftOrder => {
            cleanUpPostData(draftOrder)
            if(draftOrder.order_status == "draft"){
                newOrders.push(draftOrder)
            }
            draftOrder.order_status = "accepted"
        })

        let closeDialog = () => {
            me.props.app.setState({
                adminOrders: [],
                selectedOrder: Object.assign(new OrderItem, {
                    id: -1,
                    itemName: "",
                    itemPrice: "",
                    itemTotal: this.props.app.state.currencyName+" 0.00"
                }),
                draftOrder: false,
                bill: {
                    subtotal: 0,
                    total: 0,
                    discount: 0,
                    cash: 0,
                    decimalflag: false,
                    decimal: 0,
                }
            })
        }

        const fireConfirmAllOrderAPI = (resolve, reject) => {
            // Update that we are placing order if we are at dummy table session
            // This is especially useful for 'Enable Quick Ordering' mode as
            // user will stay at this page. Sudden switching of table session might
            // cause confusion/bugs.
            // We only change table session when user explicitly trigger it
            if (currentSession.id < 0) {
                const tempSessions = [...this.props.app.state.tempSessions]
                const indexOfTempSessionToUpdate = tempSessions.findIndex(sess => sess.id == currentSession.id)
                if (indexOfTempSessionToUpdate > -1) {
                    tempSessions[indexOfTempSessionToUpdate].isPlacingOrder = true
                    this.props.app.setState({tempSessions})
                }
            }

            const finalData = {
                orders: draftOrders,
                newOrders: newOrders,
                is_auto_close_bill: !!options.is_auto_close_bill ? 1 : 0,
                counter_id: options.counter_id,
            }

            $.ajax({
                url: '/merchants/orders',
                type: 'POST',
                contentType: "application/json",
                processData: false,
                data: JSON.stringify(finalData),
                success: (orders) => {
                    let newTableSessionId = null
                    let newOrders = orders
                    if (confirmDialog) {
                        confirmDialog.close()
                    }

                    // Load the orders and update order listing, price list, etc
                    // if this is still mounted and displayed to user
                    if (this._isMounted) {
                        closeDialog()
                        me.props.app.loadOrders(me.props.match.params.tableID)
                    }
                    if (tableSessionId) {
                        // Take note that we directly edit the tempSessions array without setState
                        // as later we will trigger an event, and that event will then call setState
                        let tempSessions = this.props.app.state.tempSessions
                        let index = tempSessions.findIndex(session => session.id == tableSessionId)
                        tempSessions.splice(index, 1)

                        if (orders && Array.isArray(orders)) {
                            const dummyTableSessionRemovedId = tableSessionId
                            newTableSessionId = orders[0].table_session_id

                            // Need to trigger event first for current active AdminOrder to know that we want to
                            // replace table session
                            $(document).trigger('app.admin-orders-dummy-session-upgraded', [dummyTableSessionRemovedId, newTableSessionId])
                        }
                    }
                    if (callback) {
                        callback()
                    }
                    resolve()

                    const checkOrdersLoaded = (retryCount, newOrders) => {
                        if (newOrders && Array.isArray(newOrders)) {
                            let order = this.props.app.state.allOrders.find(o => o.id == newOrders[0].id)
                            if (!order) {
                                if (retryCount < 10) {
                                    setTimeout(() => {
                                        checkOrdersLoaded(retryCount + 1, newOrders)
                                    }, 500);
                                }
                            }
                            else {
                                setTimeout(() => {
                                    $(document).trigger('AdminOrder.confirmAllOrderCompleted')
                                }, 200) // Allow sometime for React sort things out
                            }
                        }
                    }

                    // API completed, but we may need to delay a bit and check if table sessions and orders
                    // are loaded from Firebase first before annouce that place order action is completed
                    setTimeout(() => {
                        checkOrdersLoaded(0, newOrders)
                    }, 100);
                }
            })
                .fail((jqXHR) => {
                    let rejectData = {}
                    let is403 = false
                    if (jqXHR.status == 403) {
                        is403 = true
                        rejectData = {
                            // Unauthenticated, or credential permission not match action
                            retry: false,
                        }
                    }
                    if (jqXHR.responseText) {
                        try {
                            let json = JSON.parse(jqXHR.responseText);
                            const message = json.message || lang.unable_to_place_order_order_manually;
                            if (this._isMounted) {
                                this.setState({
                                    errorMessage: message
                                })
                            }
                            if (is403) {
                                alert(json.message)
                            }
                        }
                        catch (e) {
                            console.log(e)
                        }
                    }
                    reject(rejectData)
                })
        }

        return new Promise((resolve, reject) => {
            // ----- DEBUGGING ------ //

            // This part is for debugging purposes
            // 1. Uncomment to fake that first call to API will fail
            //    after 1 second. On second retry only will fire
            //    the actual API call
            // 2. Uncomment to fake slow internet connection that take 10 seconds
            //    to complete the API call

            // This to fail the first API to trigger retry
            // let adminOrderDebug = new AdminOrderDebug()
            // if (adminOrderDebug.failFirstAPICall(options, resolve, reject)) {
            //     console.log("Debug: Hardcoded to fail first API call")
            //     return
            // }

            // This to fire API after 10 seconds delay to fake a slow internet
            // connection. To check the effect of how other user's interaction
            // in the 10 second windows affect the result this API call
            // console.log("Will wait 10 seconds before fire API to place order")
            // setTimeout(() => fireConfirmAllOrderAPI(resolve,reject), 10000)
            // return

            // ----- END DEBUGGING ------ //

            fireConfirmAllOrderAPI(resolve, reject)
        })
    }

    copyOrder = () => {
        this.setState({
            isCopyOrder: true,
        }, () => {
            OrderRepository.instance.copyAllOrders(this.props.app.state.currentSession.id)
            .then(res => {
                toast.info("Order copied", {
                    autoClose: true,
                })
            })
            .finally(() => {
                this.setState({
                    isCopyOrder: false,
                })
            })
        })
    }

    // Default is true until explicitly set false
    getIsAutoPrintNewOrder = () => {
        return localStorage.getItem("settlement.isAutoPrintNewOrder") != "false"     // localStorage store string data only
    }
    onAutoPrintReceiptChange = () => {
        this.setState({
            is_auto_print_receipt: !this.state.is_auto_print_receipt
        })
    }

    confirmAllOrder(e, otherOptions) {
        // Cancel the focus on the button. So that Enter and Esc
        // key can be captured by <ConfirmModal> without affecting
        // the focused button
        $(e.target).blur()
        if (otherOptions && otherOptions.autoCloseBill) {
            MerchantAppData.payBill(
                (orders) => {
                    const tableSessionId = orders && Array.isArray(orders) && orders.length && orders[0].table_session_id
                    this.setState({
                        // redirectBackToAdminOrder: true,
                        newOrderTableSessionId: tableSessionId,
                        session_id: tableSessionId,
                    })
                },
                {
                    is_without_close_table: false,
                    skip_print: !this.getIsAutoPrintNewOrder(),
                    is_auto_print_receipt: this.props.app.getMerchantSettingValue('allow_auto_print_receipt_on_settlement') == 1 ? 1 : 0,
                    earn_point: 0,
                    redeem_point: 0,
                    membership_id: null,
                    other_discount: 0,
                    other_discount_type: null,
                    bill_merchant_admin_id: null,

                    // Server to auto set default values for payment amount and payment type
                    quick_settlement: otherOptions.quickSettlement ? 1 : 0,
                }
            )
            this.props.history.push(`/pos`)
        }

        else {
            this.confirmOrderOnly()
        }
    }

    confirmOrderOnly = () => {
        let message = lang.asking_place_order.replace("<br>", "\n");

        let draftOrders = this.getCurrentSessionDraftOrders()
        if (draftOrders && draftOrders.length < 1) {
            return
        }
        let tableName = this.getTable().name

        // We make a copy of the draftOrders and pass into API
        // call. Else API call will read from this.props.app.state.adminOrders
        // which will change based on user's interaction, and not safe to be
        // run on BackgroundQueue that may fail and may involve retrying
        let a = this.getCurrentSessionDraftOrders()
        let options = {
            draftOrders: JSON.parse(JSON.stringify(a)),
            counter_id: this.props.app.state.counter?.id,
        }

        const isDisableRetry = window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.disable_retry
        const placeOrder = () => {
            // Call API on background, then close the modal
            // to not block admin from further actions
            let a = {
                action: () => this.confirmAllOrderAPI(null, options, null),
                name: `Adding orders to Table ${tableName}`,
                autoRetry: true,
                maxRetryCount: !isDisableRetry && 3,
                removeFromUiAfter: 1500,
            }
            PendingQueue.add(a)
            this.setState({
                confirmModal: null
            })
            this.props.history.push(`/pos`)
        }

        let isSkipPlaceOrderConfirmation = this.props.app.isMerchantHasFeature('skip_place_order_confirm_dialog')
        if (isSkipPlaceOrderConfirmation) {
            placeOrder()
        }
        else {
            this.setState({
                confirmModal: <ConfirmModal
                    ref={this.confirmModalRef}
                    message={message}
                    buttonLayout="vertical"
                    onClose={() => {
                        this.setState({
                            confirmModal: null
                        })
                    }}
                    onYes={() => {
                        placeOrder()
                    }}
                    onNo={() => {
                        this.setState({
                            confirmModal: null
                        })
                    }}
                />
            })
        }
    }

    showVariationsTag(order) {
        let variation_ary = (order.variation_ary != undefined ? order.variation_ary : this.props.app.state.variations.filter((item) => order.variation_ids.includes(item.id)))
        const selections = order.variation_data && order.variation_data.selections || []
        let li = variation_ary.map((variation) => {
            let value = Math.abs((variation.price * 1)).toFixed(2)
            value = order.quantity * value

            let quantity = 1
            let isHasQuantity = false
            let variationDetail = selections.find(vd => vd.variation_id == variation.id)
            if (variationDetail) {
                isHasQuantity = true
                quantity = parseInt(variationDetail.quantity) || 1
            }

            let price = (variation.price > 0 ?  "+ " : "- ") + this.props.app.state.currencyName + " " + (value * quantity).toFixed(2)
            return (
                <div key={"variation-" + variation.id}>
                    <span><span style={{fontSize: "120%"}}>&#x2022;</span> {isHasQuantity ? `${quantity}x `: ""}{variation.name}</span>
                    {variation.price == 0 ? "" :
                        <div style={{ float: "right" }}>
                            {price}
                        </div>
                    }
                </div>
            )
        })
        return li
    }
    showOrderRemark(order) {
        return order.remark && <div id={"order-remark-" + order.id}>
            <span>&bull; {order.remark}</span>
        </div>
    }

    showTakeAwayTag(value) {
        return (
            <div>
                <span><span>&#10033;</span>{lang.take_away}</span>
                {value == 0 ? "" :
                    <div style={{float:"right" }}>
                        {"+ "+this.props.app.state.currencyName+" " + (value * 1).toFixed(2)}
                    </div>
                }
            </div>
        )
    }

    handleSideDish = () => {
        let orders = this.getOrders()
        let isAllSideDishCompleted = true
        for (let i = 0; i < orders.length; i++) {
            let thisOrderSideDishCompleted = orders[i].isSideDishCompleted()
            let sddGroups = Object.keys(thisOrderSideDishCompleted)
            for (let group of sddGroups) {
                if (!thisOrderSideDishCompleted[group]) {
                    // Found at least one side dish group that is not complete
                    isAllSideDishCompleted = false
                    break
                }
            }
        }
        this.setState({isAllSideDishCompleted})
    }
    handleInventory = () => {
        let inventoryLowStock = {}
        if (!this.state.isNeedHandleInventory) {
            this.setState({inventoryLowStock})
            return
        }

        let orders = this.getOrders().filter(o => o.order_status == "draft")
        for (let i = 0; i < orders.length; i++) {
            let order = orders[i]
            if (order.getMenuItem().is_out_of_stock || order.getMenuItem().is_out_of_stock_until || order.getMenuItem().isNegativeStock()) {
                inventoryLowStock[order.id] = true
                continue
            }

            // Handle choice
            if (order.option_ids && Array.isArray(order.option_ids) && order.option_ids.length) {
                const c = this.props.app.state.variation.choices.find((item) => item.id == order.option_ids[0])
                let choice = Object.assign(new Variation, c)
                if (choice.isNegativeStock() || choice.in_stock == false) {
                    inventoryLowStock[order.id] = true
                    continue
                }
            }

            // Handle options
            if (order.variation_ids) {
                let variationIds = order.variation_ids.split(",").map(id => parseInt(id))
                const options = this.props.app.state.variations.filter((item) => variationIds.indexOf(item.id) !== -1)
                options.forEach(o => {
                    let option = Object.assign(new Variation, o)
                    if (option.isNegativeStock() || option.in_stock == false) {
                        inventoryLowStock[order.id] = true
                    }
                })
            }
        }
        this.setState({inventoryLowStock})
    }

    getOrderDescription(order) {
        let me = this
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)

        if (!menuItem) {
            return null
        }
        if(this.state.draftSetDineInClicked)  {
            if(order.order_status == "draft" && order.table_session_id == this.props.app.state.currentSession.id) {
                if (order.menuItem.take_away_charge != -1) {
                    order.take_away = 0
                }
            }
        }
        if(this.state.draftSetTakeAwayClicked)  {
            if(order.order_status == "draft" && order.table_session_id == this.props.app.state.currentSession.id) {
                if (order.menuItem.take_away_charge != -1) {
                    order.take_away = 1
                }
            }
        }
        let value = menuItem.take_away_charge == 0 ? 0 : menuItem.take_away_charge * order.quantity
        return (
            (order.variation_ids == null && !order.take_away && !order.remark && !(order.side_dish_data && order.side_dish_data.selections)) ? null :
                <div className={'clearfix'} style={{ marginBottom: "5px" , color: order.order_status == "accepted"? "#66192d" : ""}}>
                    <div className={'btn-group'} role="group" aria-label="Second group" style={{ display: "block" }}>
                        {/* <span style={{ display: order.variations ? "block" : "none" }}>{lang.request + ": " + order.variations}</span>
                        <span style={{ display: order.remark ? "block" : "none" }}>{lang.remark + ": " + order.remark}</span> */}
                        {
                            order.side_dish_data && order.side_dish_data.selections && order.side_dish_data.selections.map(sd => {

                                let price = (!sd.variation.price || sd.variation.price == 0) ? 0 : CalculationHelper.round2dp(parseFloat(sd.variation.price) * sd.quantity)
                                const sign = price > 0 ? "+" : "-"
                                price = price ? price.toFixed(2) : 0

                                return <div key={sd.variation_id}>
                                    <span>
                                        - {`${(sd.quantity || 1)}x `} {sd.variation.name}
                                    </span>
                                    {
                                        price ?
                                        <div style={{ float: "right" }}>
                                            { `${sign} ${this.props.app.state.currencyName} ${price}` }
                                        </div> :
                                        ""
                                    }
                                </div>
                            })
                        }
                        { !order.take_away ? null : this.showTakeAwayTag(value) }
                        { !order.variation_ids ? null : this.showVariationsTag(order) }
                        { this.showOrderRemark(order) }
                    </div>
                </div>
        )
    }

    getTotalOrderPrice = () => {
        const currency = this.props.app.state.currencyName
        let orders = this.getOrders()
        let totalPrice = (!orders || orders.length == 0 ) ? 0 :
            orders.map((order) => {
                return (order.order_status == "void" ? "0" : order.order_total)
            })
            .reduce((order1, order2) => {
                return (parseFloat(order1) || 0) + (parseFloat(order2) || 0)
            }, 0)
        return currency + " " + totalPrice.toFixed(2)
    }

    getTable = () => {
        let tableId = this.props.match.params.tableID
        let table = this.props.app.state.tables.find((item) => item.id == tableId)
        return table
    }

    showHeader() {
        if (!this.props.app.state.tables || this.props.app.state.tables.length == 0 || !this.props.app.state.currentSession) {
            return ""
        }
        else {
            let tableId = this.props.match.params.tableID
            let table = this.props.app.state.tables.find((item) => item.id == tableId)
            let total = this.getTotalOrderPrice()

            let bill = this.props.app.state.bill;
            let paid = ""
            if(bill.total > 0 && bill.balance > 0 && (bill.total - bill.balance) > 0){
                paid = lang.paid + this.props.app.state.currencyName +" " + ((bill.total - bill.balance) * 1).toFixed(2);
            }

            let pin = ""
            if (this.props.app.state.sessions != null) {
                let tableSession = this.props.app.state.currentSession
                if (tableSession != null && tableSession.active == 1 && tableSession.pin != undefined) {
                    pin = lang.your_pin_number + tableSession.pin
                }
            }

            return <div style={{ padding: "8px", flex: "0 0 50px" }}>
                <div className="order-font" style={{ fontWeight: "bold" }}>
                    <span style={{ display: "inline-block" }}>{lang.table + " " + table.name}</span>
                    {/* <span style={{float: "right"}}>{lang.order_item + " " + this.props.app.state.adminOrders.length}</span> */}
                    <span style={{ float: "right", color: "red" }}>{total}</span>
                </div>
                <div className="item-font" style={{ fontWeight: "bold", display: "block" }}>
                    <span style={{ display: "inline-block" }}>{lang.order_item + " " + this.getOrders().length}</span>
                    <span style={{ float: "right", color: "royalblue" }}>{paid}</span>
                </div>


                <div className="clearfix">
                    {
                        this.props.app.isMerchantHasFeature('multi_table_session_per_table') &&
                        this.props.app.state.isAllowChooseTableSession ?
                            <SelectTableSession
                                app={this.props.app}
                                tableId={tableId}
                                membershipBtn={() => {
                                    return this.isMembershipModuleEnabled() && this.props.app.state.currentSession.id > 0 &&
                                        <div>
                                            {
                                                this.state.membership ?
                                                <button className="btn btn-default" onClick={this.onMembershipClicked}>
                                                    {
                                                        this.state.assigningMembership ?
                                                        <span><i className="fa fa-spinner fa-spin" /></span> :
                                                        <span className="mr-1" style={{fontSize: "16px"}}>
                                                            <strong>
                                                                Member: {this.state.membership && `${this.state.membership.name} (${this.state.membership.membership_number})`}
                                                            </strong>
                                                        </span>
                                                    }
                                                </button> :
                                                    <button id="update-order-button" className="btn btn-success"
                                                            onClick={this.onMembershipClicked}>
                                                        {
                                                            this.state.assigningMembership ?
                                                            <span><i className="fa fa-spinner fa-spin" /></span> :
                                                            <>
                                                            <i className="fa fa-user" style={{color: "white", marginRight: "10px"}}></i>
                                                                <strong> {lang.membership}</strong>
                                                            </>
                                                        }
                                                </button>
                                            }
                                        </div>
                                }}
                                onClearAllDraftOrdersClicked={this.onClearAllDraftOrdersClicked}
                                onSelectTableSessionClicked={this.onSelectTableSessionClicked}/> :
                            <>
                                <span style={{fontSize: "130%", fontWeight: "bold" }}>
                                    {lang.order} {this.props.app.state && this.props.app.state.currentSession && this.props.app.state.currentSession.queue_number}
                                </span>
                            </>
                    }
                </div>

                <div style={{display: "flex"}}>
                    <div style={{marginTop: "auto", marginBottom: "auto"}}>
                        <TableSessionCreatedBy app={this.props.app} tableSession={this.props.app.state.currentSession} />
                    </div>
                    {
                        this.props.app.isMerchantHasFeature('set_draft_orders_as_take_away') &&
                        <div className="margin mt-2" style={{ flex: "1 0 100px", textAlign: "right" }}>
                            <b style={{ fontSize: "14px", marginRight: "5px" }}>Set draft orders as: &nbsp;</b>
                            <button onClick={this.setDraftOrderAsDineIn} className="btn btn-default">
                                Dine In
                            </button>
                            <button onClick={this.setDraftOrderAsTakeAway} className="btn btn-default margin ml-2">
                                Take Away
                            </button>
                        </div>
                    }
                </div>
            </div>
        }
    }

    isLoadingMembershipData = () => {
        return this.state.assigningMembership || this.state.loadingMembership
    }

    onMembershipClicked = () => {
        if (this.props.app.state.currentSession.membership_id) {
            this.showMembershipActionModal()
        }
        else {
            // No member selected yet, show modal to select membership
            this.showSelectMembershipModal()
        }
    }

    /**
     * @param eligibility - We may already check eligibility, so can pass in and avoid repeating API/checking
     */
    showMembershipActionModal = (eligibility = {allowApplyPromotion: false, hintText: "-1", openSelectFreeItemModal: false}) => {
        let isClosed = false
        const onClose = () => {
            isClosed = true
            this.setState({membershipActionModal: null})
        }
        if (!this.membershipActionModalRef) {
            this.membershipActionModalRef = React.createRef()
        }

        const changeMembership = () => {
            onClose()
            setTimeout(() => {
                this.showSelectMembershipModal()
            }, 200)
        }

        let isRemovingMembership = false
        const removeMembership = () => {
            isRemovingMembership = true
            renderShowMembershipActionModal({isRerender: true})
            TableSessionService.assignMembership(this.props.app.state.currentSession, null)
                .then(() => {
                    onClose()
                })
                .catch((xhr) => {
                    const { errorCode, message } = getAjaxError(xhr)
                    if (this.membershipActionModalRef.current) {
                        let errorMsg = message ? message + (errorCode ? `(${errorCode})`: '') : ''
                        this.membershipActionModalRef.current.setErrorMessage(errorMsg || "Failed to remove membership")
                    }
                })
        }
        
        const applyPromotion = () => {
            onClose()
            setTimeout(this.showApplyMembershipBenefitModal, 300)
        }

        let lastModalState = {}
        const renderShowMembershipActionModal = ({allowApplyPromotion, hintText, showLoading, isRerender} = {}) => {
            // Modal already closed by user, drop further rendering from callbacks
            if (isClosed) {
                return
            }
            if (isRerender) {
                // Use back previous state
                ({ allowApplyPromotion, hintText, showLoading } = lastModalState)
            }
            else {
                // Store the state for future rerender
                lastModalState = {
                    allowApplyPromotion, hintText, showLoading
                }
            }
            this.setState({
                membershipActionModal: <BaseModal
                    onClose={onClose}
                    ref={this.membershipActionModalRef}
                    body={<div className="membership-actions">
                        {
                            hasFreeItem &&
                            <button disabled={!allowApplyPromotion} className="btn btn-primary"
                                    onClick={applyPromotion}>
                                {lang.apply_promotion} {hintText}
                                {
                                    !!showLoading && <span><i className="fa fa-spinner fa-spin"/></span>
                                }
                            </button>
                        }
                        <button className="btn btn-default" onClick={changeMembership}>{lang.change_membership}</button>
                        <button className="btn btn-warning" onClick={removeMembership}>{lang.remove_membership} {isRemovingMembership && <span className="ml-1"><i className="fa fa-spinner fa-spin"/></span>}</button>
                        <button className="btn btn-default" onClick={onClose}>{lang.close}</button>
                    </div>}
                />
            })
        }

        let hasFreeItem = false
        if (this.state.membership && this.state.membership.membership_free_items) {
            hasFreeItem = this.state.membership.membership_free_items.find(item => {
                return item.balance_quantity > 0 && moment(item.expire_at, 'YYYY-MM-DD HH:mm:ss').isAfter(moment())
            }) != null

            if (this.state.membership.membership_free_items) {
                if (eligibility.hintText !== "-1") {
                    renderShowMembershipActionModal({
                        allowApplyPromotion: eligibility.allowApplyPromotion, hintText: eligibility.hintText, showLoading: false
                    })
                }
                else {
                    this.checkEligibleApplyFreeItem({
                        onBoth: ({allowApplyPromotion, hintText}) => renderShowMembershipActionModal({allowApplyPromotion, hintText, showLoading: false})
                    })
                }
            }
        }

        // Too tired, show modal 2 times. First time with loading indicator.
        // 2nd time after above check eligibility for free item API complete
        // If we already know about the eligibility, then can skip this and directly show the final version
        if (eligibility.hintText === "-1") {
            renderShowMembershipActionModal({allowApplyPromotion: false, hintText: false, showLoading: true})
        }
    }

    checkEligibleApplyFreeItem = ({onEligible, onNotEligible, onBoth}) => {
        MembershipFreeItemRepository.getInstance().getClaimedItems(this.state.membership.membership_free_items.map(item => item.id))
            .then((res) => {
                let allowApplyPromotion = true
                let hintText = ""
                if (res && Array.isArray(res)) {
                    for (let i = 0; i < res.length; i++) {
                        const membershipFreeItems = res[i]
                        const claimedOrders = membershipFreeItems.orders
                        const claimedToday = claimedOrders.filter(order => order.bills?.length && moment(order.bills[0].updated_at).isSame(moment(), 'day'))
                        if (claimedToday.length > 0) {
                            allowApplyPromotion = false
                            hintText = ` (${lang.today_already_claimed})`
                            break
                        }
                    }
                }

                if (onEligible && allowApplyPromotion) {
                    onEligible()
                }
                if (onNotEligible && !allowApplyPromotion) {
                    onNotEligible()
                }
                if (onBoth) {
                    onBoth({allowApplyPromotion, hintText})
                }
            })
    }

    showApplyMembershipBenefitModal = (options = {autoSelect: false, autoSaveIn: 0}) => {
        if (!this.applyMembershipBenefitModalRef) {
            this.applyMembershipBenefitModalRef = React.createRef()
        }
        const onClose = () => {
            this.setState({applyMembershipBenefitModal: null})
        }

        const onSubmit = (data) => {
            TableSessionService.applyFreeItem(this.props.app.state.currentSession.id, data.membership_free_item_id, data.order.id)
                .then(() => {
                    onClose()
                })
                .catch(xhr => {
                    const { errorCode, message } = getAjaxError(xhr)
                    if (this.applyMembershipBenefitModalRef.current) {
                        let errorMsg = message ? message + (errorCode ? `(${errorCode})`: '') : ''
                        this.applyMembershipBenefitModalRef.current.setErrorMessage(errorMsg || "Failed to apply free item to ticket")
                    }
                })
        }

        this.setState({
            applyMembershipBenefitModal: <BaseModal
                onClose={onClose}
                ref={this.applyMembershipBenefitModalRef}
                body={
                    <ApplyMembershipBenefitForm
                        orders={this.getOrders()}
                        app={this.props.app}
                        membership={this.state.membership}
                        onClose={onClose}
                        onSubmit={onSubmit}
                        autoSelectOnOpen={options.autoSelect}
                        autoSaveIn={options.autoSaveIn}
                        tableSession={this.props.app.state.currentSession} />
                }
            />
        })
    }

    showSelectMembershipModal = () => {
        if (!this.selectMembershipModalRef) {
            this.selectMembershipModalRef = React.createRef()
        }
        const onClose = () => {
            this.setState({membershipModal: null})
        }
        this.setState({
            membershipModal: <SelectMembershipModal
                app={this.props.app}
                ref={this.selectMembershipModalRef}
                autoShow={true}
                onModalClosed={onClose}
                onNo={onClose}
                onYes={(membership) => {
                    this.setState({
                        membership: membership,
                        assigningMembership: true,
                    })

                    TableSessionService.assignMembership(this.props.app.state.currentSession, membership)
                        .then(() => {
                            this.autoApplyMembershipFreeItem()
                        })
                        .catch(() => {
                            this.setState({
                                membership: null,
                            })
                        })
                        .finally(() => {
                            // Timer to not have flashing issue when action change from assign membership to load
                            // membership
                            setTimeout(() => {
                                this.setState({
                                    assigningMembership: false,
                                })
                            }, 300)
                        })

                    this.selectMembershipModalRef.current && this.selectMembershipModalRef.current.close(true)
                }}
            />
        })
    }

    autoApplyMembershipFreeItem = () => {
        this.checkEligibleApplyFreeItem({
            onEligible: () => {
                // this.showMembershipActionModal({allowApplyPromotion: true, hintText: "", openSelectFreeItemModal: true})
                this.showApplyMembershipBenefitModal({autoSelect: true, autoSaveIn: 5})
            },
            onBoth: ({allowApplyPromotion, hintText}) => {
                if (!allowApplyPromotion) {
                    this.showMembershipActionModal({allowApplyPromotion, hintText})
                }
            }
        })
    }
    onClearAllDraftOrdersClicked = (tableSessionId) => {
        let adminOrders = this.props.app.state.adminOrders
        let toRemove = []

        // Get the ids of draft orders to be removed
        adminOrders.forEach((order, index) => {
            if (order.table_session_id == tableSessionId && order.order_status == 'draft') {
                toRemove.push(order.id)
            }
        })

        // Remove the draft orders
        if (toRemove.length) {
            toRemove.forEach(orderId => {
                let index = adminOrders.findIndex(order => order.id == orderId)
                if (index !== -1) {
                    adminOrders.splice(index, 1)
                }
            })
        }
        this.handleInventory()
    }
    onSelectTableSessionClicked = (e) => {
        if (e.target.value == "-1") {
            // Admin selected "New Ticket", we shall add a new temporary session
            // to store the orders
            let tempSessions = [...this.props.app.state.tempSessions]
            let currentSession = TableSessionHelper.getNewTempTableSession(this.props.match.params.tableID)
            tempSessions.push(currentSession)
            this.props.app.setState({ tempSessions, currentSession })
        }
        else {
            if (e.target.value > 0) {
                // Actual table session exist
                this.props.app.setState({
                    currentSession: this.props.app.state.sessions.find(session => session.id == e.target.value)
                })
            }
            else {
                // Dummy table session that we create, but not yet submitted to server
                this.props.app.setState({
                    currentSession: this.props.app.state.tempSessions.find(session => session.id == e.target.value)
                })
            }
        }
    }

    /**
     * @returns {Array.<OrderItem>}
     */
    getOrders = () => {
        return this.props.app.state.adminOrders.filter(order => this.props.app.state.currentSession && order.table_session_id == this.props.app.state.currentSession.id)
    }

    getTickets = () => {
        return this.props.app.state.sessions.filter(ticket => ticket.table_id == this.props.match.params.tableID)
    }

    calculatePriceByWeight = (order, priceByWeight) => {
        return order.weight * priceByWeight
    }

    /// Get the unit price of the order
    /// 1. If is choiceless order, then will the MenuItem's price
    /// 2. If is order with choice, then will be th price of the selected choice
    getUnitPrice = (order) => {
        let unitPrice = 0
        if (order.unit_price) {
            return order.unit_price
        }
        const isPickupOrDelivery = this.isPickupOrDelivery()

        const getDeliveryPrice = (item) => {
            return item.price_delivery != null ? item.price_delivery : item.price
        }

        if (order.option_ids) {
            let choice = this.props.app.state.variation.choices.find((item) => item.id == order.option_ids[0] && item.in_stock == true)
            if (choice) {
                return parseFloat(isPickupOrDelivery ? getDeliveryPrice(choice) : choice.price);
            }
            else {
                throw "isWaitingForData"
            }
        }

        let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)
        if (menuItem) {
            return parseFloat(isPickupOrDelivery ? getDeliveryPrice(menuItem) : menuItem.price)
        }
        throw "isWaitingForData"
    }

    isHasInventoryError = (order) => {
        const isHasInventoryError = order.order_status == "draft" && !!this.state.inventoryLowStock[order.id]
        return isHasInventoryError
    }
    showOrderListing() {
        let me = this
        let index = 0

        if (!this.props.app.state.orders) {
            return null;
        }

        let orders = this.getOrders()

        let currentSession = this.props.app.state.currentSession
        let isDummyTableSessionPlacingOrder = false
        if (currentSession && currentSession.id < 0 && currentSession.isPlacingOrder) {
            isDummyTableSessionPlacingOrder = true
        }

        if (isDummyTableSessionPlacingOrder && orders.length == 0) {
            return <div>
                Placing orders <span><i className="fa fa-spinner fa-spin" /></span>
            </div>
        }

        orders.sort()
        if (this.props.app.state.sort_by) {
            orders.reverse()
        }

        let isHasKitchenView = this.props.app.isMerchantHasFeature('kitchen_view')

        let li = []
        let isOrderSetBySet = false
        let lastOrder = null
        let currentSetNumber = 1
        if (currentSession && currentSession.id > 0) {
            isOrderSetBySet = currentSession.extra_data && currentSession.extra_data.order_style == OrderStyle.SET_BY_SET
        }
        else if (currentSession && currentSession.id < 0) {
            // Dummy table session for admin to place draft orders
            isOrderSetBySet = this.props.app.isOrderSetBySet()
        }

        if (isOrderSetBySet) {
            sortBySetNumber(orders)
        }

        orders.forEach((order) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id)
            let listClass = `admin-order-${order.id}`
            index++;

            let selected = false
            if (this.props.app.state.selectedOrder.id == order.id) {
                selected = true;
            }

            let totalPrice = 0;
            let isWaitingForData = false;
            let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)
            let unitPrice = 0
            try {
                unitPrice = this.getUnitPrice(order)
            }
            catch (e) {
                if (e == "isWaitingForData") {
                    isWaitingForData = true
                }
            }
            if (order.membership_free_item_id) {
                totalPrice = order.order_total * order.quantity
            }
            else if (menuItem) {
                if (unitPrice && (menuItem.is_price_per_weight || menuItem.is_price_per_pax)) {
                    let weight = typeof order.weight == 'undefined' ? 1 : order.weight
                    let pax = typeof order.pax == 'undefined' ? 1 : order.pax
                    totalPrice = menuItem.is_price_per_weight ? unitPrice * weight : unitPrice * pax
                }
                else {
                    totalPrice = unitPrice
                }
                totalPrice = totalPrice * order.quantity
            }

            const getTotalPrice = () => {
                if (isWaitingForData) {
                    return "..."
                }
                else {
                    return this.props.app.state.currencyName+" " + (totalPrice * 1).toFixed(2)
                }
            }

            let key = order.menu_item_id + "-" + index;
            const isServed = (order.quantity == order.quantity_served) && order.order_status != "void" && isHasKitchenView

            const isVoiding = this.state.voidItemMap[order.id]
            const isSideDishCompletedMap = order.isSideDishCompleted()
            const isHasUncompletedSideDish = Object.keys(isSideDishCompletedMap).find(sddGroup => {
                return isSideDishCompletedMap[parseInt(sddGroup)] === false
            })
            const isOrderHasError = isHasUncompletedSideDish || this.isHasInventoryError(order)

            if (isOrderSetBySet) {
                let headerSetNumber = setNumberHeader(lastOrder, order, currentSetNumber, (setNumber, nextLastOrder) => {
                    currentSetNumber = setNumber
                    lastOrder = nextLastOrder
                })
                if (headerSetNumber) {
                    li.push(<div key={"Set"+headerSetNumber}>Set {headerSetNumber}</div>)
                }
            }

            li.push(
                <div style={{ position: "relative", overflow: "auto", padding: "10px" }} data-id={order.id} key={key}
                    className={(selected) ? "admin-order-selected-list " + listClass : listClass}
                    onClick={me.selectOrder}>

                    <div style={{display:"flex",}}>
                        <div className="top-left-corner-rotate-45" style={{backgroundColor: "green", flex: "0 0 5px", marginRight: "5px", visibility: isServed ? "visible" : "hidden"}}>
                        </div>
                        <div className="top-left-corner-rotate-45" style={{backgroundColor: "red", flex: "0 0 5px", marginRight: "5px", visibility: isOrderHasError ? "visible" : "hidden"}}>
                        </div>

                        <div style={{ flex: "1 0 100px", marginLeft: "-10px" }}>
                            <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                                <div className="item-title" style={{
                                    fontWeight: "bold", color: order.order_status == "accepted" ? "#66192d" : "",
                                    fontStyle: order.order_status == "void" ? "italic" : "normal"
                                }}>
                                    <span style={{ width: "65%", display: "inline-block" }}>
                                        {order.order_status == "void" ? <del>{order.quantity + "x " + order.desc}</del> : order.quantity + "x " + order.desc}
                                    </span>
                                    <span style={{ float: "right" }}>
                                        {/* {"RM " + (order.order_total * 1).toFixed(2)} */}
                                        {order.order_status == "void" ? <del>{this.props.app.state.currencyName+" " + (totalPrice * 1).toFixed(2)}</del> : getTotalPrice()}
                                    </span>
                                </div>
                            </div>
                            {order.order_status == "void" ? "" : me.getOrderDescription(order)}
                            {this.showOrderDate(order)}
                            {
                                (isVoiding || order.isLoading) &&
                                <div className="pull-right">
                                    <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
        })
        return li
    }
    // showOrderServed = (order) => {
    //     return(
    //         <div style={{textAlign:"right"}}>
    //             <span className="text-success"><i>Served</i></span>
    //         </div>
    //     )
    // }

    showOrderDate(order) {
        if (order.order_status == "draft") {
            return ""
        }

        // let adminOrders = this.getOrders()
        // let order = adminOrders.length == 0 ? null : adminOrders[adminOrders.length - 1]
        let who = !order ? "" : ((order.order_by == OrderBy.ADMIN) ? lang.waiter : lang.customer)
        let orderby = !order ? "" : who
        let date = new Date(order.updated_at)
        let time = this.formatAMPM(date);

        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span className="item-info" style={{ color: "grey" }}><i>{orderby}</i></span>
                <span className="item-info" style={{ color: "grey" }}>
                    {time}
                    {/* <i className="fa fa-check text-success"></i> */}
                </span>
            </div>
        )
    }

    formatAMPM = (date) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    noPayBillAccessLevel = () => {
        this.setState({
            errorMessage: "You do not access to this module."
        })
    }
    onMergeTable = () => {
        this.setState({
            isMergeOrder: true
        })
    }
    onPickedUpClicked = () => {
        const name = `Order ${this.props.app.state.currentSession.queue_number} picked up`
        const url = `/merchant/api/table_sessions/${this.props.app.state.currentSession.id}/picked_up`
        let a = {
            action: () => {
                $.ajax({
                    url: url,
                    type: 'post',
                    success: (res) => {

                    }
                })
                    .done(() => {
                        PendingQueue.remove(a)
                    })
                    .always(() => {
                    })
            },
            name: name
        }
        PendingQueue.add(a)
        this.props.history.push(`/pos`)
    }
    closeTableSession = () => {
        const name = `Closing ticket ${this.props.app.state.currentSession.id}`
        const url = `/merchant/api/table_sessions/${this.props.app.state.currentSession.id}/reclose_for_bill_exist`
        let a = {
            action: () => {
                $.ajax({
                    url: url,
                    type: 'post',
                    success: (res) => {

                    }
                })
                    .done(() => {
                        PendingQueue.remove(a)
                    })
                    .always(() => {
                    })
            },
            name: name
        }
        PendingQueue.add(a)
        this.props.history.push(`/pos`)
    }
    showReceipt = () => {
        Bill.merchantViewBill(this.props.app.state.currentSession.id)
    }
    createTemporaryTableQr = (minute) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/merchant/api/table/${this.props.app.state.currentSession.table_id}/temporary_table_qr`,
                data: {
                    minute: minute,
                },
                type: "POST",
                success: (response) => {
                    if (response && Array.isArray(response) && response.length) {
                        resolve(response[0])
                    }
                    else {
                        resolve(response)
                    }
                },
                error: (xhr) => {
                    ajaxFails(xhr)
                    reject()
                },
            })
        })
    }

    showGenerateTemporaryQrModal = () => {
        this.setState({generateTemporaryQrModal: true})
    }
    reprintTemparyTableQr = (tempTableQrId) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/merchant/api/temporary_table_qr/${tempTableQrId}/print`,
                type: "POST",
                success: (response) => {
                    resolve(response)
                },
                error: (xhr) => {
                    ajaxFails(xhr)
                    reject()
                },
            })
        })
    }
    createNewTemporaryTableQr = (minute) => {
        this.setState({
            isPrintingQr: true
        })
        this.createTemporaryTableQr(minute)
            .then(tempTableQr => {
                this.props.app.setState({currentSession: null}, () => {
                    this.props.history.push(`/pos`)
                })
                return this.reprintTemparyTableQr(tempTableQr.id)
            })
    }
    getQRCode = () => {
        $.ajax({
            url: `/orders/${this.props.app.state.currentSession.table_id}/print_qr`,
            // url: base_url + `orders/${this.props.app.state.currentSession.table_id}/print_qr`,
            type: "GET",
            success: (response) => {
                var x = document.getElementsByClassName("snackbar-body");
                x[0].className = "snackbar-body show-snack-bar";
                setTimeout(function(){
                    x[0].className = x[0].className.replace("snackbar-body show-snack-bar", "snackbar-body");
                }, 3000);

                this.setState({
                    snackbarMessage: lang.printing
                })
            },
            error: ajaxFails,
        })
    }
    isHandHeldTerminal = () => {
        return window.isAndroidHandHeldTerminal
    }
    isPickupOrDelivery = () => {
        const tableSessionTypeId = this.props.app.state.currentSession.table_session_type_id
        return tableSessionTypeId == TableSessionType.DELIVERY || tableSessionTypeId == TableSessionType.PICKUP
    }
    isAlreadyClosedBill = () => {
        const { currentSession, } = this.props.app.state
        const { bill, } = this.state
        return  bill && bill.status == BillStatus.CLOSED
    }
    isWaitingPickup = () => {
        const { currentSession, } = this.props.app.state
        const { bill, } = this.state
        return  bill && bill.status == BillStatus.WAITING_PICKUP
    }
    isCannotEditOrder = () => {
        return this.isAlreadyClosedBill() || this.isWaitingPickup()
    }
    showButtons() {
        const { selectedOrder, currentSession, } = this.props.app.state
        const { isAllSideDishCompleted, bill, isCopyOrder, isPrintingQr } = this.state

        let adminOrders = this.getOrders()
        let adminDraftOrders = this.getCurrentSessionDraftOrders()

        let haveDraftOrders = adminOrders.length > 0 && adminDraftOrders.length > 0 //this.props.app.state.draftOrder
        let isDraft = selectedOrder.id != -1 && selectedOrder.order_status == "draft"
        let confirmOrder = adminOrders.filter((order) => order.order_status == "accepted")
        // let isConfirm = this.props.app.state.selectedOrder.id != -1 && this.props.app.state.selectedOrder.order_status == "accepted"
        let hasPrinter = (this.props.app.state.merchant.printer_id != null) || this.isHandHeldTerminal()
        let status = this.getTableStatus(this.props.match.params.tableID)

        let merchantSettings = this.props.app.state.merchant.settings;
        let hasDrawer = (merchantSettings && merchantSettings.indexOf("has_drawer") > 0) ? true : false;

        const allowPayBillModule = AccessLevel.allowPayBillModule()
        const isPayButtonEnabled = (haveDraftOrders || confirmOrder.length > 0)
        const isSettleButtonShow = allowPayBillModule

        const isShowPickedUpButton = currentSession && currentSession.is_pickup_confirmed

        const isAlreadyClosedBill = this.isAlreadyClosedBill()
        const isShowCloseTableSessionButton = isAlreadyClosedBill

        const allowVoidModule = AccessLevel.allowVoidModule()
        const isVoidShow = allowVoidModule && (selectedOrder.id != -1 && selectedOrder.order_status == "accepted");

        let extraButton = null

        let isVoidingItemId = Object.keys(this.state.voidItemMap).find(key => this.state.voidItemMap[key] == true)
        let isVoidingItem = isVoidingItemId != null

        const noInventoryError = () => {
            return Object.keys(this.state.inventoryLowStock).length == 0
        }

        const settleButtonContainer = ({onClick, btnText}) => {
            return <div style={{ flex: "1 0 100px" }} className="mr-1">
                <button style={{ width: "100%" }} id="admin-order-btn-settlement"
                    onClick={onClick}
                    className={"btn btn-success"}>
                    <i className="fa fa-cash-register order-confirm-font" style={{ color: "white", marginRight: "10px" }}></i>
                    <strong className="order-confirm-font"> {btnText}</strong>
                </button>
            </div>
        }

        // Do not show SETTLE button if is PICKUP order
        const settleButton = () => {
            let isSettlingBill = currentSession && currentSession.isSettlingBill
            let isNoInventoryError = noInventoryError()
            return !isShowCloseTableSessionButton && !isShowPickedUpButton && isSettleButtonShow && <div style={{ flex: "1 0 100px" }} className="mr-1">
                <button style={{ width: "100%"}} id="admin-order-btn-settlement"
                    onClick={isNoInventoryError && isPayButtonEnabled && isAllSideDishCompleted && !isSettlingBill ? this.enterSettlement : null}
                    className= {isNoInventoryError && isPayButtonEnabled && isAllSideDishCompleted && !isSettlingBill ? "btn btn-danger active" : "btn btn-basic disabled"} disabled={isVoidingItem}>
                    <i className="fa fa-cash-register order-confirm-font" style={{ color: isPayButtonEnabled && isAllSideDishCompleted ? "white" : "#636b6f", marginRight: "10px"}}></i>
                    <strong className="order-confirm-font"> {lang.settle} {isSettlingBill && <span><i className="fa fa-spinner fa-spin"/></span> }</strong>
                </button>
            </div>
        }

        let pickupButton = isShowPickedUpButton && settleButtonContainer({
            btnText: lang.picked_up,
            onClick: this.onPickedUpClicked,
        })

        let closeTableSessionBtn = isShowCloseTableSessionButton && settleButtonContainer({
            btnText: lang.close,
            onClick: this.closeTableSession
        })

        if (isDraft) {
            extraButton = <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="cancel-order-button" className="btn btn-danger" onClick={this.cancelOrder}>
                <strong className="order-confirm-font"> {lang.cancel}</strong>
                <i className="fa fa-ban order-confirm-font" style={{ color: "white", display: "block" }}></i>
            </button>
        }
        else if (isVoidShow) {
            extraButton = <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="void-order-button" className="btn btn-danger" onClick={this.voidOrder}>
                <strong className="order-confirm-font"> {lang.void}</strong>
                <i className="fa fa-hand-paper order-confirm-font" style={{ color: "white", display: "block" }}></i>
            </button>
        }

        let changePriceButton = this.props.app.isMerchantHasFeature('allow_change_order_price') && selectedOrder.id != -1 && <button style={{ display: "initial", height: "12vh", minHeight: "60px", whiteSpace: "normal" }} id="change-price-button" className="btn btn-default" onClick={this.changePrice}>
            <strong className="order-confirm-font"> {lang.change_price}</strong>
            <i className="fa fa-dollar-sign order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
        </button>

        const isAllowCancelOrder = this.props.app.state.currentSession && this.props.app.state.currentSession.is_cash_on_delivery
        const isAllowConfirmOrder = isAllSideDishCompleted && haveDraftOrders && noInventoryError()
        const isDineIn = (currentSession && [TableSessionType.DINE_IN, TableSessionType.DINE_IN_WITH_PAYMENT].indexOf(currentSession.table_session_type_id) > -1)
        return <div>
            {
                this.isCannotEditOrder() &&
                <div>* {lang.ticket_paid_cant_edit}</div>
            }
            <div style={{display:"flex"}}>
                {hasPrinter && this.props.app.isMerchantHasFeature('show_print_qr_at_merchant_ordering') && <div style={{ flex: "1 0 100px" }} className="mr-1">
                    {/* <button id="get-qrcode-button" style={{ width: "100%" }} disabled={isPrintingQr} className="btn btn-default" onClick={this.getQRCode}> */}
                    <button id="get-qrcode-button" style={{ width: "100%" }} disabled={isPrintingQr} className="btn btn-default" onClick={this.showGenerateTemporaryQrModal}>
                    {/* <button id="get-qrcode-button" style={{ width: "100%" }} disabled={isPrintingQr} className="btn btn-default" onClick={this.createNewTemporaryTableQr}> */}
                        <i className="fa fa-print" style={{ marginRight: "10px" }}></i>
                        <strong className="order-confirm-font"> Print QR {isPrintingQr ? <i className="fa fa-spinner fa-spin"/>: ""}</strong>
                    </button>
                </div>}
                {
                    window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.allow_copy_order &&
                    <div style={{ flex: "1 0 100px" }} className="mr-1">
                        <button style={{ width: "100%" }} id="place-order-button"
                            onClick={this.copyOrder}
                            className= {!haveDraftOrders && !isCopyOrder ? "btn btn-success active" :  "btn btn-basic disabled"}>
                            <i className="fa fa-copy order-confirm-font" style={{color: "white", marginRight: "10px" }}></i>
                            <strong className="order-confirm-font">Copy {!!isCopyOrder && <i className="fa fa-spinner fa-spin"/>}</strong>
                        </button>
                    </div>
                }

                {/* We have 2 possible mode for confirm button
                1. Normal - Place order and go back to POS
                2. Place order, then auto close bill as CASH payment, then go back to POS */}
                {this.confirmButton({isAllowConfirmOrder, isAllSideDishCompleted, haveDraftOrders})}


                {/* Go to settlement page */}
                {settleButton(isAllowConfirmOrder)}
                {pickupButton}
                {closeTableSessionBtn}
                {/* <div style={{ flex: "1 0 100px" }} className="mr-1">
                    <button style={{ width: "100%", }} id="place-order-button"
                        onClick={isSettleButtonEnabled ? this.closeTable : null}
                        className= {isSettleButtonEnabled ? "btn btn-danger active" : "btn btn-basic disabled" }>
                        <i className="fa fa-cash-register order-confirm-font" style={{ color: isSettleButtonEnabled ? "white" : "#636b6f", marginRight: "10px" }}></i>
                        <strong className="order-confirm-font"> {lang.settle}</strong>
                    </button>
                </div> */}
            </div>

            {/* <div>
                {this.printButtons(extraButton)}
            </div> */}

            <div id={`admin-order-panel-${this.props.match.params.tableID}`}
                className='grid-container'
                style={{ gridTemplateColumns: "calc(24.75% - 5px) calc(24.75% - 5px) calc(24.75% - 5px) calc(24.75% - 5px)", marginTop: "10px" }}
                data-id={this.props.match.params.tableID} >
                {
                    // 1. No point to ChangeTable on Quick Order mode as we have no way
                    //    to view other table
                    // 2. Do not allow swap if is not DineIn/DineInWithPayment table
                    status != 0 && !this.props.app.isPosQuickOrder() && isDineIn
                    ?
                    <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="print-order-button" className="btn btn-default" onClick={(e) => this.onChangeTable(e)}>
                        <strong className="order-confirm-font" style={{ whiteSpace: "normal" }}> {lang.change_table}</strong>
                        <i className="fa fa-exchange-alt order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                    </button>
                    : ""
                }

                {
                    // Do not allow merge ticket if ticket already closed
                    this.getTableSessions().length > 1 && !isAlreadyClosedBill && isDineIn && !this.isCannotEditOrder() &&
                    <button style={{ display: "initial", height: "12vh", minHeight: "60px", background: "#402089" }} id="print-order-button" className="btn btn-default" onClick={this.onMergeTable}>
                        <strong className="order-confirm-font" style={{ whiteSpace: "normal", color: "white" }}> {lang.btn_text_merge_order}</strong>
                        <i className="fa fa-code-branch order-confirm-font" style={{ color: "white", display: "block" }}></i>
                    </button>
                }

                {
                    isAllowCancelOrder ?
                        <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="print-order-button"
                            onClick={this.onClearTableClicked}
                            className={"btn btn-default"}>
                            <strong className="order-confirm-font" style={{ whiteSpace: "normal" }}> {lang.clear_table}</strong>
                            <i className="fa fa-broom order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                        </button>
                        : ""
                }
                {hasPrinter && confirmOrder.length > 0 &&
                    <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="print-order-button" className="btn btn-primary" onClick={(e) => this.printOrder(e, 1)}>
                        <strong className="order-confirm-font"> {lang.print_bill}</strong>
                        <i className="fa fa-print order-confirm-font" style={{ color: "#white", display: "block" }}></i>
                    </button>
                }
                <ViewBillButton tableSession={this.props.app.state.currentSession} />
                {hasDrawer ?
                    <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="print-order-button" className="btn btn-default" onClick={(e) => this.openDrawer(e)}>
                        <strong className="order-confirm-font"> {lang.open_drawer}</strong>
                        <i className="fa fa-money-check-alt order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                    </button>
                    : ""
                }
                {this.isPortrait() && isDraft ?
                    <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="edit-order-button" className="btn btn-warning" onClick={this.editOrder}>
                        <strong className="order-confirm-font"> {lang.edit}</strong>
                        <i className="fa fa-edit order-confirm-font" style={{ color: "white", display: "block" }}></i>
                    </button>
                    : ""
                }
                {changePriceButton}
                {extraButton}
            </div>
        </div>
    }

    confirmButton = ({isAllowConfirmOrder, isAllSideDishCompleted, haveDraftOrders}) => {
        if (this.props.app.getMerchantSettingValue(MerchantSettingKey.ADMIN_ORDER_AUTO_CLOSE_BILL_ON_CONFIRM_ORDER) == 1) {
            const btnColorClass = "btn " + (isAllowConfirmOrder ? "btn-success active" : "btn-basic disabled")
            return <div style={{ flex: "1 0 100px" }} className="mr-1">
                {/* Default button is Close Bill, if user want to confirm order without close bill, then user can open the dropdown and choose Confirm Order instead */}
                <div className="btn-confirm-order btn-group dropup" style={{display: "flex"}}>
                    <button style={{flex: "1 0 30px"}} className={`${btnColorClass}`} id="place-order-button" onClick={isAllowConfirmOrder ? (e) => this.confirmAllOrder(e, {autoCloseBill: true, quickSettlement: true}) : null}><strong className="order-confirm-font"> {lang.confirm_order_close_bill}</strong></button>
                    <button type="button" style={{width: "30px"}} className={`dropdown-toggle dropdown-toggle-split ${btnColorClass}`} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="caret"></span>
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="#" onClick={isAllowConfirmOrder ? this.confirmAllOrder : null}>{lang.confirm_order}</a>
                        <a className="dropdown-item" href="#" onClick={isAllowConfirmOrder ? (e) => this.confirmAllOrder(e, {autoCloseBill: true}) : null}>{lang.confirm_order_close_bill}</a>
                    </div>
                </div>
            </div>
        }
        else {
            // Default
            return <div style={{ flex: "1 0 100px" }} className="mr-1">
                <button style={{ width: "100%" }} id="place-order-button"
                    onClick={isAllowConfirmOrder ? this.confirmAllOrder : null}
                    className= {isAllowConfirmOrder ? "btn btn-success active" :  "btn btn-basic disabled"}>
                    <i className="fa fa-shopping-cart order-confirm-font" style={{ color: isAllSideDishCompleted && haveDraftOrders ? "white" : "#636b6f", marginRight: "10px" }}></i>
                    <strong className="order-confirm-font"> {lang.confirm_order}</strong>
                </button>
            </div>
        }
    }

    printButtons(extraButton) {
        return <>
            <div className="mt-1">* Printing the receipt will auto confirm all orders.</div>
            <div style={{ display: "flex" }} className="mt-1">
                <div style={{ flex: "1 0 50px", textAlign: "center" }} className="">
                    <button style={{ width: "90%", minHeight: "60px", padding: "2px" }} id="print-order-button" className="btn btn-default" onClick={(e) => this.printOrder(e, 1)}>
                        <strong className="order-confirm-font" style={{ fontSize: "12pt" }}>#1</strong>
                        <i className="fa fa-print order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                    </button>
                </div>
                <div style={{ flex: "1 0 50px", textAlign: "center" }} className="">
                    <button style={{ width: "90%", minHeight: "60px", padding: "2px" }} id="print-order-button" className="btn btn-default" onClick={(e) => this.printOrder(e, 2)}>
                        <strong className="order-confirm-font" style={{ fontSize: "12pt" }}>#2</strong>
                        <i className="fa fa-print order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                    </button>
                </div>
                <div style={{ flex: "1 0 50px", textAlign: "center" }} className="">
                    <button style={{ width: "90%", minHeight: "60px", padding: "2px" }} id="print-order-button" className="btn btn-default" onClick={(e) => this.printOrder(e, [1, 2])}>
                        <strong className="order-confirm-font" style={{ fontSize: "12pt" }}>#1 + #2</strong>
                        <i className="fa fa-print order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
                    </button>
                </div>
            </div>
        </>
    }

    onCloseGenerateTemporaryQrModal = () => {
        this.setState({generateTemporaryQrModal: false})
    }

    isMembershipModuleEnabled = () => {
        return this.props.app.getMerchantSettingValue(MerchantSettingKey.ENABLE_BASIC_MEMBERSHIP_MODULE) == 1
    }

    render() {
        if (!this.props.app.isReadyFor(this) || !this.props.app.state.orders) {
            return (<div></div>);
        }
        return (
            <div style={{ marginLeft: "10px" }}>
                {this.state.membershipModal}
                {this.state.membershipActionModal}
                {this.state.applyMembershipBenefitModal}
                {
                    this.state.generateTemporaryQrModal && <GenerateTemporaryQrModal
                        tableId={this.getTable().id}
                        onReprint={(tempTableQrId) => {
                            this.onCloseGenerateTemporaryQrModal()
                            this.reprintTemparyTableQr(tempTableQrId)
                        }}
                        onNo={this.onCloseGenerateTemporaryQrModal}
                        onYes={(minute) => {
                            this.onCloseGenerateTemporaryQrModal()
                            this.createNewTemporaryTableQr(minute)
                        }}
                        onClose={this.onCloseGenerateTemporaryQrModal}
                    />
                }
                {
                    this.state.isMergeOrder &&
                    <MergeOrderModal
                        app={this.props.app}
                        tableId={this.props.match.params.tableID}
                        onNegativeClicked={() => {
                            this.setState({
                                isMergeOrder: false
                            })
                        }} />
                }
                {this.state.errorMessage && <MessageModal message={this.state.errorMessage} onClose={() => this.setState({ errorMessage: null })} />}
                <TopNav
                    extraClassName="show-when-portrait-only"
                    ref={this.navRefs}
                    tableQR={this.props.match.params.tableQR}
                    table={this.props.app.state.table}
                    topTitle={`${lang.category}: ${this.state.category != null ? this.state.category.name : ""}`}
                    title={lang.menu_item}
                    orders={this.props.app.state.orders}
                    back={`/table/${this.props.match.params.tableID}/category/1`}
                    session={this.props.app.state.current_session}
                    backLabel={lang.back_to_category}
                    adminOrdering={true}
                />
                {/* 52px is TopHav height */}
                <div className="order-center-panel" style={{ paddingRight: "8px", paddingLeft: "8px", paddingBottom: "8px", height: `calc(${this.state.vh * 100}px - 52px)`, display: "flex", flexDirection: "column" }}>
                    {this.state.confirmModal}
                    {/* {this.state.snackbarMessage} */}
                    <SnackBarModal message={this.state.snackbarMessage} />

                    {this.showHeader()}
                    <div className="order-panel" style={{
                        position: "inherit", overflow: "auto",
                        display: "block", flex: "1 0 80px", maxHeight: "60vh"
                    }}>{this.showOrderListing()}</div>

                    {/* button list */}
                    <div className="mb-2" style={{ flex: "0 0 50px" }}>
                        {/* {this.showOrderDate()} */}
                        {this.showButtons()}
                    </div>
                    {this.state.confirmAlert}
                    <ChangeTableModal
                        app={this.props.app}
                        visible={this.state.changeTable != null}
                        table={this.state.changeTable}
                        tables={this.props.app.state.tables}
                        onClose={this.afterChangeTable}
                    />
                </div>
            </div>
        )
    }
}

class AdminOrderDebug {
    /**
     * Return true to skip API call
     */
    failFirstAPICall = (options, resolve, reject) => {
        if (!options.i) {
            options.i = 0
        }
        if (options.i == 0) {
            options.i++
            reject()
            return true
        }
        return false
    }
}

function ViewBillButton({ tableSession }) {
    if (tableSession && tableSession.id > 0) {
        const merchantViewBill = () => {
            Bill.merchantViewBill(tableSession.id)
        }
        return <button style={{ display: "initial", height: "12vh", minHeight: "60px" }} id="print-order-button" className="btn btn-default" onClick={merchantViewBill}>
            <strong className="order-confirm-font"> {lang.view_bill}</strong>
            <i className="fa fa-eye order-confirm-font" style={{ color: "#636b6f", display: "block" }}></i>
        </button>
    }
    return null
}

export default AdminOrder;